module.exports = __webpack_public_path__ + "img/10_27.e58c9f26.png";